import { jsxs as s, jsx as e } from "react/jsx-runtime";
import { R as d, V as m, T as n } from "../../vendor-Dd6qj6gJ.js";
import { Cell as o } from "./Cell.js";
import { Checkbox as p } from "../Checkbox/index.js";
import { IconButton as f } from "../IconButton/index.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as b } from "../../utils/omitStyleRenderProps/index.js";
import { c as g } from "../../styles.module-BF2N4g8-.js";
function $({ id: r, columns: t, children: a, ...c }) {
  const { selectionBehavior: i, allowsDragging: l } = d();
  return /* @__PURE__ */ s(m, { id: r, ...b(c), className: g.row, children: [
    l && /* @__PURE__ */ e(o, { "data-drag-cell": !0, children: /* @__PURE__ */ e(
      f,
      {
        slot: "drag",
        icon: "drag-grip",
        size: "sm",
        variant: "ghost",
        "aria-label": "Reorder row"
      }
    ) }),
    i === "toggle" && /* @__PURE__ */ e(o, { "data-selection-cell": !0, children: /* @__PURE__ */ e(p, { "aria-label": "Select row", slot: "selection" }) }),
    /* @__PURE__ */ e(n, { items: t, children: a })
  ] });
}
$.displayName = "Table.Row";
export {
  $ as Row
};
